import classnames from 'classnames';
import React from 'react';

import css from 'reactComponents/icons/defaultIconStyles.css';

export function IconTelegram({
    width = '16',
    height = '16',
    className,
    ...rest
}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
            className={classnames(css.main, className)}
            {...rest}
        >
            <path
                d=" M 14.749 1.156 C 14.327 1.283 10.449 2.731 6.931 4.156 C 3.816 5.417 1.231 6.561 0.99 6.682 C 0.209 6.945 -0.605 7.516 0.677 8.103 C 1.278 8.406 4.221 9.366 4.221 9.366 C 4.221 9.366 12.518 3.948 12.769 3.787 C 13.152 3.524 13.402 3.763 13.029 4.156 C 12.864 4.317 6.202 10.314 6.202 10.314 C 6.317 10.312 11.457 14.283 11.726 14.577 C 12.611 15.32 13.346 14.916 13.498 14.103 C 13.53 13.956 14.361 10.424 15.01 7.156 C 15.479 4.792 15.855 2.462 15.948 1.945 C 16.083 1.072 15.766 0.865 14.749 1.156 Z "
                className={css.colored}
            />
        </svg>
    );
}

export default IconTelegram;
